// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2KMtN","label":"Radio_label__14p96","checkMark":"Radio_checkMark__1rsqP","disabled":"Radio_disabled__2Y4tr"};